import React from 'react';
import Typewriter from 'typewriter-effect';

const Description = () => {
  return (
    <section id="about" className="py-12 bg-background text-bone-white md:pl-6 pl-2">
      <div className="px-3 lg:px-6 xl:px-8 2xl:px-10 text-left">
        <h1 className="text-5xl font-bold mb-8">
          <div className="gradient-text" style={{ lineHeight: '1.2' }}> {/* Adjusted line height */}
            <Typewriter
              options={{
                delay: 50,
                cursor: '|',
              }}
              onInit={(typewriter) => {
                typewriter.typeString("Zachary Nobunaga")
                  .callFunction(() => {
                    document.querySelector('.Typewriter__cursor').style.display = 'none';
                  })
                  .start();
              }}
            />
          </div>
        </h1>
        <div className="text-lg max-w-xl xl:max-w-2xl 2xl:max-w-3xl mb-6">
          <div className="code-tag" data-before="<div>" style={{ fontSize: '14px', color: 'blue' }}></div>
          <Typewriter
            options={{
              delay: 32,
              cursor: '|',
            }}
            onInit={(typewriter) => {
              typewriter.typeString("DAT associate at PwC, building software on the side.")
                .pauseFor(500)
                .typeString(" Previously, I worked at Kaiser Permanente and studied Computer Science & Business at UCR.")
                .callFunction(() => {
                  document.querySelector('.Typewriter__cursor').style.display = 'none';
                })
                .start();
            }}
          />
          <div className="code-tag" data-after="</div>" style={{ fontSize: '14px', color: 'blue' }}></div>
        </div>
        <div className="flex space-x-4 mb-4">
          <a href="#projects" className="text-blue-400 hover:underline">
            Projects
          </a>
          <a href="#work" className="text-blue-400 hover:underline">
            Experience
          </a>
          <a href="https://www.linkedin.com/in/zacharynobunaga/" target="_blank" rel="noopener noreferrer" className="text-blue-400 hover:underline">
            Connect
          </a>
        </div>
      </div>
    </section>
  );
};

export default Description;
